module.exports = __webpack_public_path__ + "img/refresh.e5e7b7f7.svg";